import { render, staticRenderFns } from "./ImportClassDialog.vue?vue&type=template&id=117755a0&scoped=true"
import script from "./ImportClassDialog.vue?vue&type=script&lang=js"
export * from "./ImportClassDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportClassDialog.vue?vue&type=style&index=0&id=117755a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117755a0",
  null
  
)

export default component.exports